import React from "react";
import { PIN_STATUS, PIN_PRIORITY } from "@/lib/utils";

export function StatusBadge({ status, size = "sm" }) {
  const s = PIN_STATUS[status] || PIN_STATUS.open;
  return (
    <span className={`pill ${s.cls}`} data-testid={`status-badge-${status}`}>
      <span className="pill-dot" />
      {s.label}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const p = PIN_PRIORITY[priority] || PIN_PRIORITY.medium;
  return (
    <span className={`pill ${p.cls}`} data-testid={`priority-badge-${priority}`}>
      {p.label}
    </span>
  );
}
